import React, { useState } from "react";
import Box from "@mui/material/Box";
import Hero from "../../../UpdateProfileForm/Hero";
import Button from "@mui/material/Button";
import General from "../../../UpdateProfileForm/General";
import About from "../../../UpdateProfileForm/About";
import Container from "@mui/system/Container";
import Education from "../../../UpdateProfileForm/Education";
import Activities from "../../../UpdateProfileForm/Activities";
import ProfileContext from "contexts/ProfileContext";
import apiRequest from "api/apiRequest";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import LoadingIndicator from "components/Utils/LoadingIndicator";
import ConfigurationContext from "contexts/ConfigurationContext";
import AuthContext from "contexts/AuthContext";

export const OurProfile = () => {
  const isFamily = "isFamily";
  const { profile, isLoading, graduateProfile, fetchGraduateProfile } =
    React.useContext(ProfileContext);
  const { schools, fetchSchools, activities, fetchActivities } =
    React.useContext(ConfigurationContext);
  const { user, setAuth } = React.useContext(AuthContext);
  const [isUpdating, setIsUpdating] = useState(false);
  const [formData, setFormData] = useState({});

  React.useEffect(() => {
    if (schools.length === 0) fetchSchools();
    if (activities.length === 0) fetchActivities();
    if (profile) {
      fetchGraduateProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile]);

  React.useEffect(() => {
    if (graduateProfile) {
      setFormData(graduateProfile);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [graduateProfile]);

  const updateFormData = (formDataKey, formDataValue) => {
    const newFormData = { ...formData };
    newFormData[formDataKey] = formDataValue;
    setFormData(newFormData);
  };

  const handleSubmit = async () => {
    if (!isUpdating) {
      try {
        setIsUpdating(true);

        // Prepare Final Data To Submit
        const dataToSubmit = { ...formData };
        // delete dataToSubmit.email;

        // dataToSubmit.about = dataToSubmit.about.map((d) => (d.value === '' ? { name: d.name, value: null } : d));
        dataToSubmit.social_media_accounts = dataToSubmit.social_media_accounts.filter(
          d => d.url !== ""
        );
        dataToSubmit.educations = dataToSubmit.educations.filter(
          e => e.outcome_id !== null && e?.degree?.trim() !== ""
        );
        for (let i = 0; i < dataToSubmit.educations.length; i++) {
          const element = dataToSubmit.educations[i];
          delete element.ourId;
        }
        // delete dataToSubmit.about_media;

        // Prepare Data that needs to be deleted
        dataToSubmit.dissociate = {};

        // Prepare social media links that needs to be deleted
        const detachedSocialMedia = graduateProfile?.social_media_accounts.filter(
          sm => !dataToSubmit.social_media_accounts.some(s => s.provider === sm.provider)
        );
        const detachedSocialMediaIds = detachedSocialMedia.map(d => ({ id: d.id }));
        if (detachedSocialMediaIds.length)
          dataToSubmit.dissociate.social_media_accounts = detachedSocialMediaIds;

        // Prepare educations that needs to be deleted
        const detachedEducations = graduateProfile?.educations.filter(
          ed => !dataToSubmit.educations.some(m => m.id === ed.id)
        );
        const detachedEducationsIds = detachedEducations.map(d => ({ id: d.id }));
        if (detachedEducationsIds.length)
          dataToSubmit.dissociate.educations = detachedEducationsIds;

        console.log(dataToSubmit);
        const response = await apiRequest({
          method: "PUT",
          url: `/graduates/me`,
          data: dataToSubmit,
        });
        if (response?.data?.token?.value) {
          const authToken = `Bearer ${response?.data?.token?.value}`;
          setAuth(user, authToken);
        }
        setIsUpdating(false);
        toast.success("Graduate Profile Updated!");
      } catch (error) {
        toast.error(error);
      } finally {
        setIsUpdating(false);
      }
    }
  };

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <React.Fragment>
      <Hero />
      <General formData={formData} updateFormData={updateFormData} />
      <Education formData={formData} updateFormData={updateFormData} />
      <About formData={formData} updateFormData={updateFormData} />
      <Activities formData={formData} updateFormData={updateFormData} allActivities={activities} />
      <Container>
        <Box my={10} display="flex" justifyContent="flex-end">
          <Button
            sx={{ width: "233px", height: "60px" }}
            className="MuiButton-profile"
            variant="contained"
            color="secondary"
            disabled={isUpdating ? true : false}
            onClick={handleSubmit}
          >
            {isUpdating ? <CircularProgress style={{ color: "white" }} /> : "Save Changes"}
          </Button>
        </Box>
      </Container>
    </React.Fragment>
  );
};

export default OurProfile;
